import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { Grid } from "@mui/material";
import { Actions } from "../Modal";
import { Form, Input, Submit } from "../Form";
import { createCalendar } from "../../features/calendars/calendarsSlice";

export default function Create(){
    const dispatch = useDispatch();
    const methods = useForm({ shouldUnregister: true });
    const onSubmit = values => dispatch(createCalendar({ values, setError: methods.setError }))

    return(
        <Actions title={'Nuevo Calendario Escolar'}>
            <Form methods={methods} onSubmit={onSubmit}>
                <Grid container spacing={2}>
                    <Input name={'nombre'} label='Nombre' min={5} max={5} regEx={/[0-9]{4}[AB]{1}/} />
                    <Submit />
                </Grid>
            </Form>
        </Actions>
    )
}